/*!
 * Created by netlogix GmbH & Co. KG
 *
 * @copyright netlogix GmbH & Co. KG
 */

import { ConstraintViolation, User } from '@shared/models';

export interface UsersState {
  users: User[];
  currentUser?: User;
  isActionPending: boolean;
  persistViolations: ConstraintViolation[];
}

export const initialState: UsersState = {
  users: [],
  isActionPending: false,
  persistViolations: []
};
